<template>
  <div>
    <SearchOpts
      v-if="!onlyView"
      v-model="medicamentoSelected"
      :searchService="medicamentosService.searchByTerm"
      :placeholder="'Buscar medicamento por nombre...'"
      :omit="omitMedicamentos"
    />


    <b-card 
      style="border:1px solid #c9c9c9" 
      v-if="medicamentoSelected" 
      class="my-3"
    >
      <b-row class="d-flex align-items-center">
        <label class="col-2">Cantidad</label>

        <b-form-input 
          class="col-2 mx-1" 
          v-model="currentMedicamento.cantidad" 
          type="number" 
          min="0"
          :max="medicamentoSelected.numMax" 
          required 
        />

        <label v-if="medicamentoSelected">
          Cant. maxima permitida: {{ medicamentoSelected.numMax }}
        </label>

      </b-row>


      <b-row class="my-1 d-flex align-items-center">
        <label class="col-2">Frecuencia</label>
        <b-form-input 
          class="col-8 mx-1" 
          v-model="currentMedicamento.frecuencia" 
        />
      </b-row>

      <b-row class="my-1 d-flex align-items-center">
        <label class="col-2">Duracion</label>
        <b-form-input 
          v-model="currentMedicamento.duracion" 
          class="col-8 mx-1" 
        />
      </b-row>

      <b-row class="my-1 d-flex align-items-center">
        <label class="col-2">Via</label>
        <span class="mx-1">{{ medicamentoSelected.presentacion }}</span>
      </b-row>

      <b-row class="my-1 d-flex align-items-center">
        <label class="col-2">Dosis</label>

        <b-form-input 
          v-model="currentMedicamento.dosis.number" 
          type="number" 
          min="0" 
          class="col-2 ml-1" 
        />

        <v-select 
          class="col-2 px-0" 
          placeholder="Seleccione una opciones" 
          :options="dosisOpts"
          :reduce="option => option" 
          label="text" 
          taggable
          v-model="currentMedicamento.dosis.tipo"
        />
      </b-row>

      <b-row>
        <b-col>
          <label>Observación</label>
          <b-form-textarea 
            id="v-observacion"
            v-model="currentMedicamento.observacion" 
            type="text" 
          />
        </b-col>

      </b-row>

      <b-row class="mt-2">

        <b-col class="d-flex justify-content-end">
          <b-button 
            variant="info" 
            @click="onAddMedicamentoToList()" 
            style="cursor: pointer"
          >
            <i 
              class="fas fa-solid fa-plus" 
              style="margin-right: 10px" 
              title="Agregar Diagnostico" 
            />
            Agregar
          </b-button>
        </b-col>

      </b-row>

    </b-card>

    <RecetaTable
      :onlyView="onlyView"
      :medicamentosList="medicamentosList"
    />
  </div>
</template>

<script>
import vSelect from "vue-select";
import { SearchOpts } from '@/shared/components';
import { addNewOpt } from '@/shared/helpers';
import { medicamentosService } from "../../services";
import RecetaTable from "./RecetaTable.vue";

export default {

  name: "RecetaList",

  props: {

    value: {
      type: Array,
      required: true
    },

    onlyView: {
      type: Boolean,
      default: false
    }
  },

  components: {
    SearchOpts,
    vSelect,
    RecetaTable
  },


  data() {
    return {
      onAddNewOpt: addNewOpt,
      medicamentoSelected: null,

      currentMedicamento:{
        medicamento:null,
        cantidad: 0,
        frecuencia: "",
        duracion: "",
        via: null,
        dosis:{
          number: 0,
          tipo: null,
          text: ""
        },
        observacion: ""
      },

      medicamentosList: this.value,
      medicamentosService: medicamentosService,

      tableFields:[],

      viaOpts: [
        "ORAL",
        "PARENTERAL",
        "RECTAL",
        "TÓPICA",
        "INHALATORIA",
        "INTRADÉRMICA",
        "SUBCUTÁNEA",
        "INTRAMUSCULAR",
        "INTRAVENOSA",
      ],

      dosisOpts: [
        { value: "ml", text: "ML" },
        { value: "l", text: "L" },
        { value: "%", text: "%" },
        { value: "gr", text: "GR" },
        { value: "mgr", text: "MGR" },
      ],

    }
  },

  methods: {

    onAddMedicamentoToList(){

      this.onValidateFormMedicamento();

      const { dosis } = this.currentMedicamento

      const newMedicamento = {
        ...this.currentMedicamento,
        medicamento: this.medicamentoSelected,
        dosis: `${dosis?.number} ${dosis?.tipo.text}`
        
      }

      this.medicamentosList.push(newMedicamento);

      console.log(this.medicamentosList);

      this.onResetForm();

    },

    onResetForm(){

      this.medicamentoSelected = null;
      
      this.currentMedicamento = {
        medicamento:null,
        cantidad: 0,
        frecuencia: "",
        duracion: "",
        via: null,
        dosis:{
          number: 0,
          tipo: null,
          text: ""
        },
        observacion: ""
      }
    }
  },


  computed: {

    isValidForm(){
      if( this.currentMedicamento.cantidad === 0){
        // this.errors.cantidad.push('Debe ser mayor a 0');
        return false;
      }

      return true;
    },

    omitMedicamentos(){
      return this.medicamentosList.map( 
        m => ({ id: m.medicamento.id, token: m.medicamento.token })
      );
    }
  },

  watch: {
    medicamentosList: {
      handler(newVal) {

        console.log(newVal);
        this.$emit('input', newVal);
      },
      deep: true
    },
  }

}
</script>